import DynamicInputs from '../../../../../components/DynamicInputs'
import { usePolicyParametersContext } from '../../context/policyParametersContext'
import { useReduxSelector } from '../../../../../hooks/useReduxSelector'
import { Typography } from '@lightbeamai/design-system'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Check, X } from 'phosphor-react'

export const RegexDynamicInputs = () => {
  const intl = useIntl()
  const { detection, patchDetection, mode } = usePolicyParametersContext()
  const validationResult = useReduxSelector((state) => state.attributes.validationResult)
  const patternMatches = useMemo(() => validationResult?.patternMatches || {}, [validationResult])
  const { regexValues } = detection
  const { isView } = mode
  const setRegexValues = (regexValues: string[]) => patchDetection({ regexValues })

  const suffixContent = !validationResult
    ? []
    : regexValues.map((val, index) => {
        if (!val) return null
        const matchedCount = patternMatches[val]?.length || 0

        return (
          <Typography
            key={`suffix-content-ca-${index}`}
            variant="baseMinus2"
            color="custom"
            style={{ color: matchedCount ? '#406E00' : '#8A1000' }}
            className="flex-row align-center"
          >
            {matchedCount ? (
              <Check size={16} color="currentColor" />
            ) : (
              <X size={16} color="currentColor" />
            )}
            <span className="xs-ml-4">
              {intl.formatMessage(
                { id: 'attributeManagementSettings.customAttributes.matches' },
                { matched: matchedCount }
              )}
            </span>
          </Typography>
        )
      })

  return (
    <DynamicInputs
      placeholderId="regexPlaceholder"
      inputs={regexValues}
      setInputs={setRegexValues}
      disabled={isView}
      suffixContent={suffixContent}
    />
  )
}
